<template>
  <div>
    <errors-alert :errors="errors"></errors-alert>
    <div>
      <form @submit.prevent="promiseUpdateUser = updateUser()">
        <div class="container-fluid">
          <div class="col-12">

            <div class="row form-group">
              <label for="user-name" class="col-form-label col-4 col-xl-3 text-muted">Name:</label>
              <div class="col-4">
                <input type="text"
                       id="user-name"
                       class="form-control"
                       :class="{'is-invalid': showUserNameInvalidMessage}"
                       v-model="userData.name">
                <div v-show="showUserNameInvalidMessage" class="invalid-feedback">
                  Please provide a User Name.
                </div>
              </div>
              <div v-if="isDeleteUserAllowed(user)" class="position-absolute left-auto right-0">
                <a href="#" role="button" class="btn btn-danger mr-2" tabindex="-1"
                   @click="$root.$emit('bv::show::modal', modalIdDeleteUser)">
                  <icon class="btn-icon" name="trash" :inverse="true"/>
                  Delete User
                </a>
              </div>
            </div>

            <field class="my-3">
              <div slot="label">E-mail:</div>
              <div slot="value">{{ user.email }}</div>
            </field>
            <field>
              <div slot="label">Password:</div>
              <div slot="value">
                <a href="#" role="button" class="btn btn-primary"
                   @click="$root.$emit('bv::show::modal', modalIdChangePassword)">
                  <icon class="btn-icon" name="pencil-alt"/>
                  Change Password
                </a>
              </div>
            </field>

            <div class="row mt-3">
              <button class="btn btn-success"
                      v-busy-button="promiseUpdateUser"
              >
                Save Changes
              </button>
            </div>

          </div>
        </div>
      </form>
    </div>
    <modal-change-password :modalId="modalIdChangePassword" :user="user"></modal-change-password>
    <modal-confirm-delete
      :modalId="modalIdDeleteUser"
      @userDeleted="userDeleted"
      :user="user">
    </modal-confirm-delete>
  </div>
</template>

<script>
  import Field from '@/components/administration/common/Field'
  import ErrorsAlert from '@/components/administration/common/ErrorsAlert'
  import ChangePassword from '@/components/administration/user/ChangePassword'
  import ConfirmDeleteUser from '@/components/administration/user/ConfirmDeleteUser'
  import notificationService from '@/services/notification/notification.service'
  import userService from '@/services/amio-api/user.service'
  import usersComponentService from '@/services/security/users.service'
  import store from '@/config/store'
  import clone from 'ramda/src/clone'
  import 'vue-awesome/icons/pencil-alt'

  function handleError(error, next) {
    if (error.response && error.response.status === 404) return next('/not-found')
    if (error) log.error(error)

    next()
  }

  export default {
    components: {
      field: Field,
      'errors-alert': ErrorsAlert,
      'modal-confirm-delete': ConfirmDeleteUser,
      'modal-change-password': ChangePassword
    },

    store: {
      user: 'administration.userEdit.user'
    },

    data() {
      return {
        modalIdChangePassword: 'modal-change-password',
        modalIdDeleteUser: 'modal-delete-user',
        promiseUpdateUser: null,
        showUserNameInvalidMessage: false,
        errors: []
      }
    },

    computed: {
      userData() {
        return clone(this.user)
      }
    },

    methods: {
      isDeleteUserAllowed: usersComponentService.isDeleteUserAllowed,

      clearPromise() {
        this.promiseUpdateUser = null
      },

      userDeleted() {
        usersComponentService.addUserWaitsForDeletion(this.user)
        this.$router.push({name: 'administration.settings.users.list'})
      },

      updateUser() {
        if (!this.validateUserName()) return

        return userService.update(this.user.id, {name: this.userData.name}, [422])
          .then(updatedUser => {
            notificationService.success('Changes were successfully saved')
            this.user = updatedUser
            this.errors = []
          })
          .then(this.clearPromise)
          .catch(error => {
            if (error.response.status !== 422) return

            log.debug('wrong name entered', error)
            this.errors = error.response.data.errors
            this.clearPromise()
          })
      },

      validateUserName() {
        const isUserNameValid = !!this.userData.name
        this.showUserNameInvalidMessage = !isUserNameValid
        return isUserNameValid
      }
    },

    beforeRouteEnter(to, from, next) {
      const storeUserId = store.administration.userEdit.user.id
      const isUserAlreadyLoaded = storeUserId === to.params.id
      if (isUserAlreadyLoaded) return next()

      userService.get(to.params.id, [404])
        .then(user => {
          next(vm => {
            user.name = user.name || ''
            vm.user = user
          })
        })
        .catch(error => handleError(error, next))
    },

    beforeRouteUpdate(to, from, next) {
      userService.get(to.params.id, [404])
        .then(user => {
          user.name = user.name || ''
          this.user = user
        })
        .catch(error => handleError(error, next))
    }
  }
</script>
